export type AppLanguage = 'en' | 'id' | 'es';

export const APP_DEFAULT_LANGUAGE: AppLanguage = 'en';
